module.exports = __webpack_public_path__ + "82d0fcbbe00d04683a9476b2ebf2e36f.pdf";